import React from "react";
import classNames from "classnames";

import { Notification } from "../../../common/notification";

import { Props } from "./types";
import styles from "./styles.scss";

function NotificationWrapper(props: Props) {
  const [isDismissed, setIsDismissed] = React.useState(false);

  React.useEffect(() => {
    const timer = setTimeout(() => setIsDismissed(true), props.lifeTimeInMs);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div
      onTransitionEnd={props.dismissNotification}
      className={classNames(styles.notificationWrapper, {
        [styles.dismissed]: isDismissed,
      })}
    >
      <Notification
        messages={props.messages}
        isSuccess={props.isSuccess}
        isWarning={props.isWarning}
        close={props.dismissNotification}
      />
    </div>
  );
}

export { NotificationWrapper };
